import React from "react";
import "./styles/App.css";
import Board from "./Components/Board";
import TopBar from "./Components/TopBar";
import Helppanel from "./Components/Helppanel";
import { GameProvider } from "./GameContext";
import FullscreenToggle from "./FullscreenToggle";
interface VodyanoyApp {
  GameType: 'ball' | 'beaker';
  VolumeA: number;
  VolumeB:number;
  WinVolume:number;
}

const AppContent: React.FC<VodyanoyApp>= ({ GameType,VolumeA,VolumeB,WinVolume }) => {
  return (
    <div id="vod-content">
      <div className="vod-conteiner">
        <div className="vod-Logo-name">
          <a className="vod-logo" href="https://kotobot.app/index.html">
            <img className="vod-logo" src="/img/kotobot.svg" alt="Kotobot logo" />
          </a>
           <img className="vod-mainsubtitle" src='/img/vodyanoy/title_vodyanoy.svg' alt="title name"/>
          <FullscreenToggle/>
        </div>
        <TopBar />
        <Board GameType={GameType} VolumeA ={VolumeA} VolumeB ={VolumeB} WinVolume ={WinVolume} />
        <Helppanel />
      </div>
    </div>
  );
};

const App: React.FC<VodyanoyApp>=  (props)  => {
  return (
    <GameProvider>
      <AppContent GameType={props.GameType}  VolumeA ={props.VolumeA} VolumeB ={props.VolumeB} WinVolume ={props.WinVolume}/>
    </GameProvider>
  );
};

export default App;